/* LM: Inline Maak de look compleet (PDP). Zelfde logica als de Shop the Look-modal, maar zonder overlay. 20 okt: Meld mij-knop opent het aanmeldvenster; link "Chat met ons" opent Gorgias (chatknop op mobiel PDP verborgen via css). */
(function () {
  /* Link "Vraag over dit artikel? Chat met ons" in Verzenden & retour opent de Gorgias-chat */
  if (!window._lmChatLink) {
    window._lmChatLink = true;
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-lm-chat]');
      if (!a) return;
      var G = window.GorgiasChat;
      if (!G || typeof G.open !== 'function') return; /* geen chat geladen: link gaat naar de contactpagina */
      e.preventDefault();
      try {
        var p = typeof G.init === 'function' ? G.init() : null;
        if (p && typeof p.then === 'function') p.then(function () { G.open(); }); else G.open();
      } catch (err) { window.location.href = a.getAttribute('href'); }
    });
  }

  if (customElements.get('pdp-complete-look')) return;

  function track(eventName, data) {
    try { window.Shopify?.analytics?.publish?.(eventName, data); } catch (e) {}
    if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event: eventName, ...data });
  }

  function nlBisSuccess() {
    const s = document.querySelector('.qa-bis-modal__success');
    if (s && /you.re in/i.test(s.textContent)) s.textContent = 'Gelukt! We laten het je weten zodra dit artikel weer op voorraad is.';
  }
  nlBisSuccess(); /* ook voor de Meld mij-knop van het hoofdproduct, dat hetzelfde venster gebruikt */

  class PdpCompleteLook extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (e) => {
        const bis = e.target.closest('[data-stl-atc].klaviyo-bis-trigger');
        if (bis) {
          e.preventDefault();
          if (typeof window.openQaBisModal !== 'function' || !bis.dataset.variantId) return;
          const item = bis.closest('[data-stl-item]');
          const nameEl = item.querySelector('.lm-ctl__name');
          const name = nameEl && nameEl.firstChild ? nameEl.firstChild.textContent.trim() : '';
          const size = item.querySelector('.lm-ctl__input:checked')?.value || '';
          nlBisSuccess();
          window.openQaBisModal(bis.dataset.variantId, name, size);
          track('complete_the_look_inline_bis_open', { variant_id: bis.dataset.variantId, source_product_handle: this.dataset.sourceProductHandle || null });
          return;
        }
        const btn = e.target.closest('[data-stl-atc]:not([disabled]):not(.klaviyo-bis-trigger)');
        if (btn) this._add(btn);
      });
      this.addEventListener('change', (e) => {
        const input = e.target.closest('.lm-ctl__input');
        if (!input) return;
        const item = input.closest('[data-stl-item]');
        this._update(item, this._resolve(item));
      });
    }

    _variants(item) {
      return JSON.parse(item.querySelector('[data-stl-variants]')?.textContent || '[]');
    }

    _resolve(item) {
      const sel = {};
      const groups = item.querySelectorAll('[data-stl-option-group]');
      groups.forEach((g) => {
        const c = g.querySelector('.lm-ctl__input:checked');
        if (c) sel[parseInt(c.dataset.optionPosition, 10) - 1] = c.value;
      });
      if (Object.keys(sel).length < groups.length) return null;
      const key = (i) => ['o1', 'o2', 'o3'][i];
      const matches = this._variants(item).filter((v) => Object.entries(sel).every(([i, val]) => v[key(parseInt(i, 10))] === val));
      return matches.find((v) => v.available) || matches[0] || null;
    }

    _update(item, variant) {
      const btn = item.querySelector('[data-stl-atc]');
      if (!btn) return;
      btn.classList.remove('klaviyo-bis-trigger', 'is-soldout');
      if (!variant) {
        btn.textContent = btn.dataset.addText;
        btn.disabled = true;
        delete btn.dataset.variantId;
        return;
      }
      btn.dataset.variantId = variant.id;
      btn.disabled = false;
      if (variant.available) {
        btn.textContent = btn.dataset.readyText;
      } else {
        btn.textContent = btn.dataset.soldoutText;
        btn.classList.add('is-soldout');
        if (btn.dataset.bisTrigger === 'true') btn.classList.add('klaviyo-bis-trigger');
        else btn.disabled = true;
      }
    }

    async _add(btn) {
      const id = parseInt(btn.dataset.variantId, 10);
      if (!id) return;
      const ready = btn.dataset.readyText;
      btn.disabled = true;
      btn.classList.add('is-loading');
      const sections = [];
      if (document.querySelector('cart-drawer')) sections.push('cart-drawer');
      if (document.getElementById('cart-counter')) sections.push('cart-counter');
      try {
        const payload = { id, quantity: 1 };
        if (sections.length) { payload.sections = sections; payload.sections_url = window.location.pathname; }
        const res = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload)
        });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const data = await res.json();
        track('complete_the_look_inline_add_to_cart', {
          source_product_id: this.dataset.sourceProductId || null,
          source_product_handle: this.dataset.sourceProductHandle || null,
          product_id: data.product_id,
          product_handle: data.handle,
          variant_id: data.variant_id,
          price: data.final_price / 100,
          currency: window.Shopify?.currency?.active || null
        });
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        btn.innerHTML = btn.dataset.addedText;
        this._refresh(data.sections);
        setTimeout(() => {
          btn.textContent = ready;
          btn.classList.remove('is-added');
          btn.disabled = false;
        }, 2200);
      } catch (err) {
        console.error('[LM CTL] toevoegen mislukt:', err.message);
        btn.classList.remove('is-loading');
        btn.disabled = false;
      }
    }

    _refresh(rendered) {
      if (rendered) {
        const parser = new DOMParser();
        if (rendered['cart-drawer']) {
          const t = document.querySelector('#CartDrawer-Body');
          const s = parser.parseFromString(rendered['cart-drawer'], 'text/html').querySelector('#CartDrawer-Body');
          if (t && s) t.innerHTML = s.innerHTML;
        }
        if (rendered['cart-counter']) {
          const t = document.querySelector('#shopify-section-cart-counter');
          const s = parser.parseFromString(rendered['cart-counter'], 'text/html').querySelector('#shopify-section-cart-counter');
          if (t && s) t.innerHTML = s.innerHTML;
        }
      }
      if (typeof updateCartCounters === 'function') updateCartCounters();
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
    }
  }

  customElements.define('pdp-complete-look', PdpCompleteLook);
})();
